import { Menu } from '@headlessui/react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { addHours, parseISO } from 'date-fns';
import { format as formatTZ, utcToZonedTime } from 'date-fns-tz';
import Api from '../api';

const formatInTimeZone = (date, fmt, tz = 'UTC') => formatTZ(utcToZonedTime(date, tz), fmt, { timeZone: tz });

export const AddToCalender = ({ text = false, event, service }) => {
  if (!event.start_at) return null;

  const eventDetails = `${event.name} of ${service.name}

  Located at: ${event.venue.address}

  View obituary and support the family at: ${service.service_url}`;

  const googleFormat = (date) => formatInTimeZone(date, "yyyyMdd'T'HHmmss'Z'");
  const outlookFormat = (date) => formatInTimeZone(date, "yyyy-M-dd'T'HH:mm:ssxxx");

  const googleLink = new URL('https://calendar.google.com/calendar/r/eventedit');
  googleLink.searchParams.set('text', `${service.name}-${event.name}`);
  googleLink.searchParams.set('dates', `${googleFormat(parseISO(event.start_at))}/${googleFormat(addHours(parseISO(event.start_at), 2))}`);
  googleLink.searchParams.set('location', event.venue.address);
  googleLink.searchParams.set('details', eventDetails);

  const outlookLink = new URL('https://outlook.live.com/calendar/0/deeplink/compose');
  outlookLink.searchParams.set('startdt', outlookFormat(parseISO(event.start_at)));
  outlookLink.searchParams.set('enddt', outlookFormat(addHours(parseISO(event.start_at), 2)));
  outlookLink.searchParams.set('subject', `${service.name}-${event.name}`);
  outlookLink.searchParams.set('body', eventDetails);
  outlookLink.searchParams.set('location', event.venue.address);

  const links = [
    {
      name: 'Google',
      url: googleLink.toString(),
    },
    {
      name: 'Outlook',
      url: outlookLink.toString(),
    },
    {
      name: 'Apple',
      url: Api.getICS(event.hash),
    },
    {
      name: 'ICS',
      url: Api.getICS(event.hash),
    },
  ];

  return (
    <Menu as="div" className="add-to-calender-menu">
      <Menu.Button>
        <div className="add-to-calender-button" title="Add to calendar">
          {text ? <span className="add-to-calender-text">Add to calendar</span> : <CalendarIcon className="add-to-calender-icon" />}
        </div>
      </Menu.Button>
      <Menu.Items className="add-to-calender-menu-items">
        {links.map((link) => (
          <Menu.Item key={link.name}>
            {({ active }) => (
              <a target="_blank" className={'add-to-calender-menu-button'} href={link.url}>
                {link.name}
              </a>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
};
